export default __webpack_public_path__ + "static/media/website.15f3e425.png";